import React, { Component } from 'react'
import RModal from 'react-modal'
import { Close } from './icons'
import styles from './Modal.scss'
import PropTypes from 'prop-types'

class CommonModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    hideModal: PropTypes.func,
    closeOnClick: PropTypes.bool,
    onModalShow: PropTypes.func,
    onModalHide: PropTypes.func
  }

  componentWillUpdate(nextProps) {
    if (this.props.isOpen && !nextProps.isOpen) {
      if (nextProps.onModalHide) {
        nextProps.onModalHide()
      }
    } else if (!this.props.isOpen && nextProps.isOpen) {
      if (nextProps.onModalShow) {
        nextProps.onModalShow()
      }
    }
  }

  componentWillUnmount() {
    if (this.props.onModalHide) {
      this.props.onModalHide()
    }
  }

  render() {
    const { closeOnClick, isOpen, children, hideModal, widthFixed, ...rest } = this.props
    return (
      <RModal
        isOpen={isOpen}
        onRequestClose={hideModal}
        contentLabel="Modal"
        className={widthFixed ? styles.modalFixed : styles.modal}
        overlayClassName={styles.overlay}
        bodyOpenClassName={styles.modalbodyOpen}
        shouldCloseOnOverlayClick={closeOnClick}
        {...rest}>
        {children}
      </RModal>
    )
  }

  static Header = ({ children, hideModal, ...rest }) => (
    <div className={styles.header} {...rest}>
      {children}
      <Close className={styles.icon} onClick={hideModal} />
    </div>
  )

  static Body = React.forwardRef(({ children, ...rest }, ref) => (
    <div className={styles.body} ref={ref} {...rest}>
      {children}
    </div>
  ))

  static Footer = ({ children, ...rest }) => (
    <div className={styles.footer} {...rest}>
      {children}
    </div>
  )

  static Buttons = ({ children, ...rest }) => (
    <div className={styles.buttons} {...rest}>
      {children}
    </div>
  )
}

export const withModal = Child =>
  class extends Component {
    static displayName = 'ModalContainer'
    constructor(props) {
      super(props)
      this.state = {
        isOpen: false
      }
    }
    showModal = () => {
      this.setState({ isOpen: true })
    }
    hideModal = () => {
      this.setState({ isOpen: false })
    }
    render() {
      return (
        <Child showModal={this.showModal} isModalOpen={this.state.isOpen} hideModal={this.hideModal} {...this.props} />
      )
    }
  }

export default CommonModal

export const Modal = withModal(({isModalOpen, showModal, hideModal, children}) => (
  <CommonModal isOpen={isModalOpen}>
    {isModalOpen && children({showModal, hideModal})}
  </CommonModal>
))

